import useDashboardAccess from "@/hooks/useDashboardAccess";
import { CurrentSubscription, subscriptionService } from "@/services/subscription";
import { useQuery } from "@tanstack/react-query";

export const subscriptionKey = ["subscription", "current"];

export type Tone = "ok" | "warn" | "danger";

export function toneOf(s: CurrentSubscription): Tone {
  if (s.status !== "Active" || s.daysLeft <= 3) return "danger";
  return s.daysLeft <= 14 ? "warn" : "ok";
}

// Only managers see the subscription; until the backend answers, `available` stays false and nothing renders.
export default function useSubscription() {
  const { isManager } = useDashboardAccess();
  const query = useQuery({
    queryKey: subscriptionKey,
    queryFn: subscriptionService.current,
    enabled: isManager,
    retry: false,
    staleTime: 5 * 60_000,
    refetchOnWindowFocus: true,
  });
  return { subscription: query.data, available: isManager && !!query.data, isLoading: query.isLoading && isManager, refetch: query.refetch };
}
